import React, { useMemo } from 'react'
import { MenuItem, FormControl, Select, Paper, InputLabel } from '@mui/material'

export default function SimpleSelect({options, dataset, selectedValue, setSelectedValue, disable, label, customClassName, elevation=2}) {

  const validOptions = useMemo(() => {
    if (dataset) {
      return options.map(item => <MenuItem key={item.columnValue} value={item}>{item.columnName}</MenuItem>)
    } 
    return options.map(item => <MenuItem key={item.value} disabled={item.disable} value={item.value}>{item.name}</MenuItem>)
  },[options, dataset])

  return (
    <Paper elevation={elevation}>
        <FormControl variant="filled" fullWidth disabled={disable}>
          <InputLabel>{label}</InputLabel>
          <Select className={customClassName} disableUnderline value={selectedValue} onChange={setSelectedValue}>
            {validOptions} 
          </Select>
        </FormControl>
    </Paper>
  )
}